import * as THREE from 'three';

export const spriteText = {
  draw: (message) => {
    const fontface = 'Arial';
    const fontsize = 32;
    const borderThickness = 1;
    const borderColor = { r: 0, g: 0, b: 0, a: 1.0 }; // background color
    const backgroundColor = { r: 255, g: 180, b: 100, a: 1.0 }; // border color
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    context.font = `Bold ${fontsize}px ${fontface}`;
    const metrics = context.measureText(message);
    const textWidth = metrics.width;

    context.fillStyle = `rgba(${backgroundColor.r},${backgroundColor.g},${backgroundColor.b},${backgroundColor.a})`;
    context.strokeStyle = `rgba(${borderColor.r},${borderColor.g},${borderColor.b},${borderColor.a})`;
    context.lineWidth = borderThickness;
    spriteText.roundRect(context, borderThickness, borderThickness, textWidth, fontsize * 1.4, 6);
    context.fillStyle = 'rgba(0, 0, 0, 1.0)';
    context.fillText(message, borderThickness, fontsize + borderThickness);

    // canvas contents will be used for a texture
    const texture = new THREE.Texture(canvas);
    texture.needsUpdate = true;
    const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
    const sprite = new THREE.Sprite(spriteMaterial);
    sprite.scale.set(100, 50, 20);
    return sprite;
  },

  // DRAW ROUNDED RECTANGLE
  roundRect: (ctx, x, y, w, h, r) => {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo((x + w) - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, (y + h) - r);
    ctx.quadraticCurveTo(x + w, y + h, (x + w) - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, (y + h) - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  },
};

export default { spriteText };
